import { useLocalizedHref } from "@libraries/web-framework";
import { useIntl } from "react-intl";

import {
    ProductNavBar,
    ProductNavLink
} from "@/components/wpl/product-navbar/src";

const JiraSoftwareNav = () => {
    const intl = useIntl();

    return (
        <ProductNavBar
            productHref={useLocalizedHref("/software/jira")}
            productName="jirasoftware"
            freeHref={useLocalizedHref("/software/jira/free")}
            ariaLabel={intl.formatMessage({
                id: "wacJiraSoftwareNavigation.logo-label",
                defaultMessage: "Jira Software logo"
            })}
            dataProductKey="jiraSoftware"
        >
            <ProductNavLink
                label={intl.formatMessage({
                    id: "software-jira.navbar.features",
                    defaultMessage: "Features"
                })}
                href={useLocalizedHref("/software/jira/features")}
            />
            <ProductNavLink
                label={intl.formatMessage({
                    id: "software-jira.navbar.product-guide",
                    defaultMessage: "Product guide"
                })}
                href={useLocalizedHref(
                    "/software/jira/guides/getting-started/introduction"
                )}
            />
            <ProductNavLink
                label={intl.formatMessage({
                    id: "software-jira.navbar.templates",
                    defaultMessage: "Templates"
                })}
                href={useLocalizedHref("/software/jira/templates")}
            />
            <ProductNavLink
                label={intl.formatMessage({
                    id: "software-jira.navbar.pricing",
                    defaultMessage: "Pricing"
                })}
                href={useLocalizedHref("/software/jira/pricing")}
            />
            <ProductNavLink
                label={intl.formatMessage({
                    id: "software-jira.navbar.enterprise",
                    defaultMessage: "Enterprise"
                })}
                href={useLocalizedHref("/software/jira/enterprise")}
            />
        </ProductNavBar>
    );
};

JiraSoftwareNav.displayName = "JiraSoftwareNav";

export default JiraSoftwareNav;
